import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import NavBar from "./NavBar";

// Player routes render edge-to-edge, without the site chrome.
const PLAYER_ROUTE = /^\/(PlayMovie|PlayEpisode)\/[^/]+/i;

const AppLayout = () => {
  const { pathname } = useLocation();
  const bare = PLAYER_ROUTE.test(pathname);

  return (
    <div className="flex min-h-screen flex-col">
      {!bare && <NavBar />}
      <main className="flex-1">
        <Outlet />
      </main>
      {!bare && <Footer />}
    </div>
  );
};

export default AppLayout;
